export class PreHangCache {
    public cachedSelections: { [key: string]: any } = {}
    private LOCAL_STORAGE_KEY: string
    private cacheableSelections:Array<string> = [
        'bore',
        'boreBackset',
        'hingeSize',
        'hingeRadius',
        'hingeFinish',
        'stop',
        'jambMaterial',
        'jambWidth',
        'jambType',
        'customJambWidth',
        'latchPrep',
        'machineHingeSize',
        'machineHingeRadius',
        'machineHingeThickness',
        'machineBore',
        'machineBoreBackset',
        'machineLatchPrep',
        'boreOne',
        'boreTwo',
        'noHingePrep',
        'useHingeStandard',
        'useStandardBore',
        'hingeOne',
        'hingeTwo',
        'hingeThree',
        'hingeFour'
    ]

    public constructor(key: string) {
        this.LOCAL_STORAGE_KEY = key
        this.loadCachedSelections()
    }

    private storeCachedSelections() {
        localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(this.cachedSelections))
    }

    private loadCachedSelections() {
        try {
            const val = localStorage.getItem(this.LOCAL_STORAGE_KEY)
            if (val) {
                this.cachedSelections = JSON.parse(val)
            }
        } catch (err: any) {
            console.error(`Failed to load cached prehang selections: ${err.message}`)
        }
    }

    public addToCache(key: string, value: any) {
        if(this.cacheableSelections.includes(key)) {
            this.cachedSelections[key] = value
            this.storeCachedSelections()
        }
    }
}
